<template>
  <fieldset>
    <legend>
      <slot />
    </legend>
    <div :class="props.checkBoxGroupWrapperClass">
      <div
        v-for="(
          { checkboxLabel, checkboxValue, disabled }, index
        ) in props.config"
        :key="checkboxValue"
      >
        <gsp-checkbox
          :ref="(el) => (fieldRef[index] = el)"
          class="vm-mr-2 vm-mt-2"
          :value="checkboxValue"
          :checked="value.includes(checkboxValue)"
          @change="checkboxChanged"
          v-html="checkboxLabel"
          :disabled="disabled"
        >
        </gsp-checkbox>
      </div>
    </div>
    <gsp-text-field-error-message class="vm-capitalize">
      {{ errorMessage }}
    </gsp-text-field-error-message>
  </fieldset>
</template>

<script setup>
import initValidationField, {
  fieldProps,
  fieldEmits,
} from "~/composables/validation-field";
import { ref } from "vue";

const props = defineProps({
  ...fieldProps,
  config: {
    type: Object,
    required: true,
  },
  checkBoxGroupWrapperClass: {
    type: String,
    default: "",
  },
});

const emit = defineEmits({
  ...fieldEmits,
});

const fieldRef = ref([]);

const { value, errorMessage, validate } = initValidationField({
  props,
  emit,
  fieldRef,
});

function checkboxChanged(e) {
  if (e.target.checked)
    !value.value.includes(e.target.value) &&
      (value.value.push(e.target.value), value.value.sort());
  else
    value.value.includes(e.target.value) &&
      value.value.splice(value.value.indexOf(e.target.value), 1);

  validate();
}
</script>
